// extracted by mini-css-extract-plugin
module.exports = {"legend":"Health-legend-1G2Lv","loading":"Health-loading-1dLVv LoadingIndicator-loading-3SEvF","status":"Health-status-wNxP5","healthOk":"Health-healthOk-2hstb"};